import React, { useMemo } from "react";
import useSWR from "swr";
import { motion } from "framer-motion";
import HeroSection from "../../Components/Common/HeroSection";
import Contact from "../Home/Components/Contact";
import { StaticPageApiUrls } from "../../Api/Auth/ApiUrls";
import { noAuthfetcher } from "../../Api/swrConfig";
import { Loader } from "../../Components/Common/Loader";
import NotFound from "../Notfound";

const DEFAULT_BACKGROUND =
  "https://storage.googleapis.com/road-to-fe/uploads/1741417535659-07d447cd-82a2-4b1b-8c08-9fffeaaefa18-colleagues-doing-team-work-project_23-2149361607.avif";

const StaticPageTemplate = ({
  slug,
  defaultTitle,
  defaultSubtitle = "One Platform Many Options To Explore",
  defaultHeroImage = DEFAULT_BACKGROUND,
  defaultBody = "",
  defaultFeatureImage,
}) => {
  const { data, error, isLoading } = useSWR(
    slug ? StaticPageApiUrls.info(slug) : null,
    noAuthfetcher
  );

  const pageData = data?.data;

  const contentParsed = useMemo(() => {
    if (!pageData?.content) return {};
    try {
      return typeof pageData.content === "string"
        ? JSON.parse(pageData.content)
        : pageData.content;
    } catch (parseError) {
      console.warn("Failed to parse static page content", parseError);
      return {};
    }
  }, [pageData]);

  const heroTitle = pageData?.title || contentParsed?.heroTitle || defaultTitle;
  const heroSubtitle =
    pageData?.headerDescription ||
    contentParsed?.heroSubtitle ||
    defaultSubtitle;
  const heroImage =
   
    defaultHeroImage;

  const bodyHtml =
    contentParsed?.content ||
    contentParsed?.bodyContent ||
    pageData?.bodyDescription ||
    defaultBody;

  const featureImage =
   
  pageData?.image || defaultFeatureImage;

  if (error) {
    return <NotFound />;
  }

  if (isLoading) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 1, y: -40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <HeroSection
        title={heroTitle}
        backgroundImage={heroImage}
        subtitle={heroSubtitle}
      />
      <div className="gap-3 container mx-auto sm:mt-12 mt-4 flex justify-center md:justify-between items-start flex-wrap md:flex-nowrap px-2">
        <div className="max-w-4xl w-full prose prose-neutral">
          <div
            dangerouslySetInnerHTML={{
              __html: bodyHtml || "",
            }}
          />
        </div>
        {featureImage && (
          <div>
            <img
              src={featureImage}
              alt={heroTitle}
              className="w-full h-72 object-cover rounded-md"
            />
          </div>
        )}
      </div>
      <Contact />
    </motion.div>
  );
};

export default StaticPageTemplate;

